import Box from '@material-ui/core/Box'

/** @deprecated use Grid instead **/
const DeprecatedBox = Box

export default DeprecatedBox
